module.exports = __webpack_public_path__ + "img/footer-bg_md.6c564be.webp";